module.exports = __webpack_public_path__ + "static/media/suki-logo-navbar.3824f139.svg";